<h3 class="widget-title">{{ title() }}</h3>

@if (hasSelection) {
  <mat-card class="selected-card">
    <mat-card-content>
      <div class="selected-header">
        <div class="selected-icon">
          <mat-icon>business</mat-icon>
        </div>
        <div class="selected-info">
          <span class="selected-name">{{ selectedPractice()!.practiceName }}</span>
          @if (selectedPractitioner()) {
            <span class="selected-sub">{{ selectedPractitioner()!.name }}</span>
          }
        </div>
        <button mat-icon-button type="button" color="warn" (click)="clearSelection()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
} @else {
  <div class="search-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Search by name</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput
             type="text"
             [value]="searchQuery()"
             (input)="onSearchInput($event)"
             placeholder="Type at least 2 characters...">
      @if (searchQuery().length > 0) {
        <button mat-icon-button matSuffix type="button" (click)="clearSearch()">
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (showResults()) {
      <div class="search-results mat-elevation-z3">
        @if (filteredResults().length === 0) {
          <div class="no-results">
            <span>No results found</span>
          </div>
        } @else {
          @for (item of filteredResults(); track item.practice.practiceId + '-' + (item.practitioner?.id ?? 0)) {
            <mat-card class="result-card" tabindex="0" role="button" (click)="selectItem(item)" (keydown.enter)="selectItem(item)" (keydown.space)="selectItem(item); $event.preventDefault()">
              <mat-card-content>
                <div class="result-header">
                  <div class="result-icon">
                    @if (item.practitioner) {
                      <mat-icon>person</mat-icon>
                    } @else {
                      <mat-icon>business</mat-icon>
                    }
                  </div>
                  <div class="result-info">
                    <span class="result-name">{{ item.displayName }}</span>
                    <span class="result-sub">{{ item.subText }}</span>
                  </div>
                  <mat-icon color="primary">chevron_right</mat-icon>
                </div>
              </mat-card-content>
              <mat-divider></mat-divider>
            </mat-card>
          }
        }
      </div>
    }
  </div>

  @if (required() && !hasSelection) {
    <p class="required-hint">* Please select a recipient</p>
  }
}
